import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "汇总依据", -1)
const _hoisted_4 = { class: "Search_item_content" }
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "content_total" }
const _hoisted_8 = { class: "content_list" }
const _hoisted_9 = { class: "content_list_item_top" }
const _hoisted_10 = { class: "content_list_item_top_left" }
const _hoisted_11 = { class: "content_list_item_top_right" }
const _hoisted_12 = { class: "created" }
const _hoisted_13 = { class: "content_list_item_sx" }
const _hoisted_14 = {
  key: 0,
  class: "green"
}
const _hoisted_15 = {
  key: 1,
  class: "yellow"
}
const _hoisted_16 = {
  key: 2,
  class: "red"
}
const _hoisted_17 = { class: "content_list_item_content" }
const _hoisted_18 = { class: "content_list_item_content_item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "规格：", -1)
const _hoisted_20 = { class: "content_list_item_content_item_nr" }
const _hoisted_21 = {
  key: 0,
  class: "content_list_item_content_item"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "仓库：", -1)
const _hoisted_23 = { class: "content_list_item_content_item_nr" }
const _hoisted_24 = {
  key: 1,
  class: "content_list_item_content_item"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "货位：", -1)
const _hoisted_26 = { class: "content_list_item_content_item_nr" }

import vSearch from "@/components/common/Search.vue"
    import { getwStockExtList } from "@/apis/materialStorage"
    import { judgmentPlatform } from "@/utils/utils"

    import { ref, reactive, onMounted } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const controlData = ref({
        finished: false,
        loading: false,
        total: 0,
        page: 0,
        capacity: 10,
    })
    const data = ref({
        materialName: '',
        groupType: '3'
    })
    // 根据平台是否需要设置top
    let status = ref<boolean>(false);
    const refreshing = ref(false)
    const list: any = ref([])

    const groupTypes: Array<{name: string, id: string, isActive: boolean }> = reactive([
        { name: '默认', id: '3', isActive: true },
        { name: '物料', id: '1', isActive: false },
        { name: '物料+仓库', id: '2', isActive: false },
    ])

    // 重置
    const reset = () => {
        controlData.value.page = 0;
        data.value.groupType = '3'
        controlData.value.finished = false;
        groupTypes.forEach((item: {name: string, id: string, isActive: boolean }, index: number) => {
            item.isActive = index === 0;
        })
        data.value.materialName = ''
        list.value = [];
        getLists();
    }

    onMounted(() => {
        status.value = judgmentPlatform();
        controlData.value.page = 0
    })

    const changeGroup = (i: any): void => {
        groupTypes[i].isActive = !groupTypes[i].isActive;
        data.value.groupType = groupTypes[i].id
        for (const index in groupTypes) {
            if (index != i) {
                // console.log(index, i)
                const item = groupTypes[index]
                item.isActive = false
            }
        }
    }

    const loadData = (): void => {
        getLists()
    }

    // 获取计划列表数据
    const getLists = (): void => {
        if (!controlData.value.finished) {
            controlData.value.loading = true;
            controlData.value.page = controlData.value.page + 1;
            getwStockExtList({
                capacity: controlData.value.capacity,
                model: {
                    materialOrBatch: data.value.materialName,
                    groupType: data.value.groupType,
                    greaterZero: 1
                },
                page: controlData.value.page,
                sorts: [
                    {
                        direction: "ASC",
                        property: "publishDate",
                    }
                ]
            }).then((res: any) => {
                    if (refreshing.value) {
                        list.value = []
                        refreshing.value = false;
                    }
                    controlData.value.loading  = false;
                    controlData.value.total = res.data.total;
                    if (res.code === 200) {
                        if (res.data.records.length < controlData.value.capacity) {
                            controlData.value.finished = true;
                        }
                        if (controlData.value.page === 1) {
                            list.value = res.data.records;
                        } else {
                            list.value.push(...res.data.records)
                        }
                    }
                })
                .catch((err: any) => {
                    controlData.value.loading = false;
                    controlData.value.finished = true;
                    if (refreshing.value) {
                        list.value = []
                        refreshing.value = false;
                    }
                })
            // .finally(() => {
            //   console.log('结束')
            //   controlData.value.loading = false;
            // })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        controlData.value.finished = false;
        controlData.value.page = 0
        controlData.value.loading = true;
        getLists();
    }

    // 接收子组件传来的输入框值
    const searchInput = (val: string): void => {
        data.value.materialName = val;
        submit()
    }

    // 搜索弹框提交
    const submit = (): void => {
        controlData.value.page = 0;
        controlData.value.finished = false;
        list.value = [];
        getLists();
    }


return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        ref: "Search",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "仓库名称/物料编码"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupTypes), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", { tag_active: item.isActive }]),
                    key: item.id,
                    onClick: ($event: any) => (changeGroup(i))
                  }, _toDisplayString(item.name), 11, _hoisted_6))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ], 2),
    _createElementVNode("div", _hoisted_7, "共" + _toDisplayString(controlData.value.total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: controlData.value.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((controlData.value.loading) = $event)),
          finished: controlData.value.finished,
          "finished-text": "没有更多了~",
          onLoad: loadData
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString('库存：' + item.num + item.unitName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (item.qualityType==0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "合格 | "))
                      : _createCommentVNode("", true),
                    (item.qualityType==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "不良 | "))
                      : _createCommentVNode("", true),
                    (item.qualityType==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "报废 | "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(item.procedureName ? item.procedureName : '-') + " | ", 1),
                    _createElementVNode("span", null, _toDisplayString(item.batch ? item.batch : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.attr), 1)
                    ]),
                    (data.value.groupType == '3' || data.value.groupType == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.wareHouseName ? item.wareHouseName : '-'), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (data.value.groupType == '3' || data.value.groupType == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.locationName), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})